import React, { PropTypes } from 'react';

import GrayPanel from '../../components/GrayPanel/GrayPanel';
import ModalAlert from '../../components/ModalAlert/ModalAlert';
import { runService } from '../../actions/eservices';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import CustomizedMap from './CustomizedMap';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';

import Select from 'react-select';
import pans from './panStyle.scss';

import v from './validators';

class WykrHipoteki extends React.Component {

  state = {
    building_type: null,
    town: null,
    street: null,
    building_number: null,
    local_number: null,
    postal_code: null,
    post_town: null,


    teryt: null,

    selectedParcels: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
  };

  validators = {
    building_type: [v.NotSelected],
  };

  errorSpanStyle = {
    color: 'red',
    fontSize: '10px',
  };

  inputStyle = { borderRadius: '0' };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    // Pobieram teryt z linku i przypisuje do state
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.searchParams.get('district');

    this.setState({
      teryt: c,
    });
  }

  insertTestData = () => {
    this.setState({
      building_type: 'lokalu mieszkalnego',
      town: 'miejscowosc',
      street: 'ulica',
      building_number: '1',
      local_number: '111',
      postal_code: '22-110',
      post_town: 'Poczta'
    });
  };

  handleChangeSelect = (e, name) => {
    this.setState({ [name]: e.value }, () => this.validate(name));
    if (name == 'building_type' && e.value != 'działki gruntu nr') {
      this.validators['town'] = [v.NotNull];
      this.validators['street'] = [v.NotNull];
      this.validators['building_number'] = [v.NotNull];
      this.validators['postal_code'] = [v.NotNull];
      this.validators['post_town'] = [v.NotNull];
      if (e.value != 'budynku') {
        this.validators['local_number'] = [v.NotNull];
      }
    } else {
      this.validators['town'] = [];
      this.validators['street'] = [];
      this.validators['building_number'] = [];
      this.validators['local_number'] = [];
      this.validators['postal_code'] = [];
      this.validators['post_town'] = [];
    }
  };

  htmlDecode(input) {
    if (typeof window !== 'undefined') {
      const e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  };

  handleChange = (e, name) => {
    this.setState({ [name]: e.target.value, }, () => this.validate(name));
  };

  getSelectErrorStyle = (name_state) => {
    const selectErrorStyle = {
      borderColor:
        Object.keys(this.state.errors).indexOf(name_state) > -1 &&
          this.state.errors[name_state] !== null &&
          this.state.errors[name_state].length > 0
          ? 'red'
          : '#ccc',
    };
    return selectErrorStyle;
  }

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validate = (field, callback = null) => {
    let newState = null;
    if (field && Object.keys(this.validators).indexOf(field) > -1) {
      const checks = this.validateField(field);
      newState = {
        errors: {
          ...this.state.errors,
          [field]: checks,
        },
      };
    }
    else {
      let errors = { ...this.state.errors };
      for (const field of Object.keys(this.validators)) {
        const checks = this.validateField(field);
        errors = { ...errors, [field]: checks };
      }
      newState = {
        errors: {
          ...errors
        },
      };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  onHide = () => this.setState({ showError: false });

  onJobFinish = (resp) => {
    if (this.props.serviceInfo.user.userType === 'local') {
      window.location.href = `${this.nextStep}${resp.jobId}`;
    } else {
      window.location.href = `${this.nextStep}${resp.jobId}?customerId=${this.props.query.customerId}`;
    }
  };

  onJobFailed = () => this.setState({
    isWorking: false,
    errorText: 'Wystąpił błąd po stronie serwera. Administrator portalu został poinformowany o zaistniałej sytuacji.',
    errorTitle: 'Tymczasowa niedostępność usługi.',
    showError: true,
  });

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (this.state.building_type === 'działki gruntu nr') {
      if (this.state.selectedParcels.length === 0) {
        this.setState({
          errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }
    }
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Formularz zawiera błędy.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      let description = '';
      if (this.state.building_type === 'działki gruntu nr') {
        description = ' ' + this.state.selectedParcels[0].label + ' obręb ' + this.state.selectedParcels[0].obreb;
      } else {
        if (this.state.building_type === 'budynku') {
          description = ', adres: ' + this.state.town + ' ul. ' + this.state.street + ' ' + this.state.building_number + ' ' + this.state.postal_code + ' ' + this.state.post_town;
        } else {
          description = ', adres: ' + this.state.town + ' ul. ' + this.state.street + ' ' + this.state.building_number + '/' + this.state.local_number + ' ' + this.state.postal_code + ' ' + this.state.post_town;
        }
      }

      const data = {
        service_data: {
          building_type: this.state.building_type,
          description: description,
          fk_userID: this.props.serviceInfo.user.ID,
          teryt: this.state.teryt
        },
        teryt: this.state.teryt,
        shortName: this.props.serviceInfo.eservice.shortName,
        user: { ...this.props.serviceInfo.user },
      };
      this.props
        .runService(this.props.serviceInfo.eservice.shortName,
          this.props.district,
          data)
        .then(resp => {
          this.onJobFinish(resp);
        });
    }
  };

  startService = () => {
    this.validate(null, this.postValidation);
  };
  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  render() {
    // layout classes
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-7';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    const optionsBuildingType = [
      {
        label: 'lokal mieszkalny',
        value: 'lokalu mieszkalnego',
      },
      {
        label: 'lokal użytkowy',
        value: 'lokalu użytkowego',
      },
      {
        label: 'działka gruntu',
        value: 'działki gruntu nr',
      },
      {
        label: 'budynek',
        value: 'budynku',
      },
    ];

    this.serviceData = [
      {
        label: 'Rodzaj nieruchomości', // Nazwa wyświetlana
        state: this.state.building_type, // Jaki state bedzie trzymal dane
        name_state: 'building_type', // Nazwa state'a zeby zmieniac
        placeholder: 'Wybierz z listy...',
        type_input: 1, // 0 - zwykly input, 1 - React Select
        options: optionsBuildingType, // Tablica z wyborami,
      },
    ];

    this.bulidingData = [
      {
        label: 'Miejscowość', // Nazwa wyświetlana
        state: this.state.town, // Jaki state bedzie trzymal dane
        name_state: 'town', // Nazwa state'a zeby zmieniac
        placeholder: 'Miejscowość...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Ulica', // Nazwa wyświetlana
        state: this.state.street, // Jaki state bedzie trzymal dane
        name_state: 'street', // Nazwa state'a zeby zmieniac
        placeholder: 'Ulica...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Numer budynku', // Nazwa wyświetlana
        state: this.state.building_number, // Jaki state bedzie trzymal dane
        name_state: 'building_number', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer budynku...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Kod pocztowy', // Nazwa wyświetlana
        state: this.state.postal_code, // Jaki state bedzie trzymal dane
        name_state: 'postal_code', // Nazwa state'a zeby zmieniac
        placeholder: 'Kod pocztowy...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Poczta', // Nazwa wyświetlana
        state: this.state.post_town, // Jaki state bedzie trzymal dane
        name_state: 'post_town', // Nazwa state'a zeby zmieniac
        placeholder: 'Poczta...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
    ];

    this.localData = [
      {
        label: 'Miejscowość', // Nazwa wyświetlana
        state: this.state.town, // Jaki state bedzie trzymal dane
        name_state: 'town', // Nazwa state'a zeby zmieniac
        placeholder: 'Miejscowość...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Ulica', // Nazwa wyświetlana
        state: this.state.street, // Jaki state bedzie trzymal dane
        name_state: 'street', // Nazwa state'a zeby zmieniac
        placeholder: 'Ulica...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Numer budynku', // Nazwa wyświetlana
        state: this.state.building_number, // Jaki state bedzie trzymal dane
        name_state: 'building_number', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer budynku...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Numer lokalu', // Nazwa wyświetlana
        state: this.state.local_number, // Jaki state bedzie trzymal dane
        name_state: 'local_number', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer lokalu...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Kod pocztowy', // Nazwa wyświetlana
        state: this.state.postal_code, // Jaki state bedzie trzymal dane
        name_state: 'postal_code', // Nazwa state'a zeby zmieniac
        placeholder: 'Kod pocztowy...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Poczta', // Nazwa wyświetlana
        state: this.state.post_town, // Jaki state bedzie trzymal dane
        name_state: 'post_town', // Nazwa state'a zeby zmieniac
        placeholder: 'Poczta...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
    ];

    return (
      <div>
        <br />
        {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ? (
          <div>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            <GrayPanel title="Dane">
              {this.serviceData.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />

                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={this.getSelectErrorStyle(v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
              {(this.state.building_type && this.state.building_type != 'działki gruntu nr') ? (
                (this.state.building_type === 'budynku') ? (
                  this.bulidingData.map((v, i) => (
                    <div key={i} className="row mobile-row container" style={rowStyle}>
                      <div className={labelCol}>
                        <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                      </div>
                      <div className={inputCol}>
                        {v.type_input == 0 ? (
                          <input
                            className="form-control"
                            style={{
                              width: '100%',
                              borderColor:
                                Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                                  this.state.errors[v.name_state] !== null &&
                                  this.state.errors[v.name_state].length > 0
                                  ? 'red'
                                  : '#ccc',
                            }}
                            value={v.state}
                            placeholder={v.placeholder}
                            onChange={e => this.handleChange(e, v.name_state)}
                          />

                        ) : null}

                        {/* RENDER ERROS IN SPAN */}
                        {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                          this.state.errors[v.name_state] !== null &&
                          this.state.errors[v.name_state].length > 0
                          ? this.state.errors[v.name_state].map((val, index) => (
                            <span key={index} style={this.errorSpanStyle}>
                              {val}
                            </span>
                          ))
                          : null}
                      </div>
                    </div>
                  ))
                ) :
                  this.localData.map((v, i) => (
                    <div key={i} className="row mobile-row container" style={rowStyle}>
                      <div className={labelCol}>
                        <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                      </div>
                      <div className={inputCol}>
                        {v.type_input == 0 ? (
                          <input
                            className="form-control"
                            style={{
                              width: '100%',
                              borderColor:
                                Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                                  this.state.errors[v.name_state] !== null &&
                                  this.state.errors[v.name_state].length > 0
                                  ? 'red'
                                  : '#ccc',
                            }}
                            value={v.state}
                            placeholder={v.placeholder}
                            onChange={e => this.handleChange(e, v.name_state)}
                          />
                        ) : null}
                        {/* RENDER ERROS IN SPAN */}
                        {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                          this.state.errors[v.name_state] !== null &&
                          this.state.errors[v.name_state].length > 0
                          ? this.state.errors[v.name_state].map((val, index) => (
                            <span key={index} style={this.errorSpanStyle}>
                              {val}
                            </span>
                          ))
                          : null}
                      </div>
                    </div>
                  )
                  )
              ) : null}
              </GrayPanel>
              {(this.state.building_type && this.state.building_type === 'działki gruntu nr') ? (
                <GrayPanel title={'Wybierz działkę'}>
                <div className="help-desc">
                  W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden z dwóch dostępnych sposobów wyboru działki:<br />
                  <ol>
                    <li> Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer działki. W celu dodania kolejnej działki należy powtórzyć czynność.</li>
                    <li>Wskazać działkę w oknie mapy wykorzystując przycisk <samp>"Wskaż działki na mapie"</samp>.</li>
                  </ol>
                  Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku <samp>"Odznacz wszystko"</samp>.
              </div>
                <CustomizedMap
                  serviceType={this.props.serviceInfo.eservice.shortName}
                  setParcels={this.setParcels}
                  selectedParcels={this.state.selectedParcels}
                  obreby={this.props.serviceInfo.precints}
                  district={this.props.districts[this.props.prefix]}
                  prefix={this.props.prefix}
                  mapState={this.props.mapstates[0]}
                  settings={this.props.serviceInfo.eservice.mapConfig}
                  dokumentType={this.props.serviceInfo.eservice}
                />
              </GrayPanel>
              ): null }
                
            <div className="row mobile-row pull-right">
              <button
                className="btn btn-primary"
                style={rowStyle}
                onClick={() => this.startService()}
              >
                Złóż wniosek
              </button>
            </div>
            {this.props.serviceInfo.user &&
                this.props.serviceInfo.user.roles &&
                this.props.serviceInfo.user.roles.indexOf('superadmin') > -1 ? (
                  <button onClick={this.insertTestData} className="btn btn-primary">
                    Insert test data
                </button>
                ) : null}
              <EmptyFileDownloader className="btn btn-primary" position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
          </div>
        ) : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

WykrHipoteki.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.object,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WykrHipoteki),
);


// WEBPACK FOOTER //
// src/routes/eservices/WykrHipoteki.js